export const LOGIN_REDIRECT_URL_SESSION_STORAGE_KEY = 'login_redirect';
export const LOGIN_REDIRECT_QUERY_PARAM_KEY = 'redirect_to';
export const HAS_ACCOUNT_HISTORY_KEY = 'hasAccountPageHistory';
